// extracted by css-extract-rspack-plugin
var _1 = "FCq9u9UOKusEum9S";
var _2 = "JtBmxHR2OowaIKWe";
var _3 = "HBJGQ0jnbZEaTZPV";
var _4 = "hUZrC_nLZwCGO5A4";
export { _1 as "StudyDetailsAccordion__collapse", _2 as "StudyDetailsAccordion__description", _3 as "StudyDetailsAccordion__details", _4 as "StudyDetailsAccordion__details__lineItem" }
